module.exports = "/images/vendor/flag-icon-css/flags/1x1/tw.svg?26cc9d596b2dc8b90f177afc9c390242";